import { render } from "./RichLevel.vue?vue&type=template&id=10a6d7db"
import script from "./RichLevel.vue?vue&type=script&lang=js"
export * from "./RichLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__